<template>
  <view class="container">
    <image class="resouce" webp src="{{leftImg}}" bindtap="goToNy"/>
    <image class="resouce" webp src="{{rightImg}}"  bindtap="goToDj"/>
  </view>
</template>
<script>
import { createComponent } from '@mpxjs/core'
import { goTo, trackEvent, sendXspmClick, is, utils } from '@didi/webx-js'
import { chapter } from '../../lib/utils.js'
createComponent({
  properties: {
    template: String,
    params: Object,
  },
  data() {
    return {}
  },
  computed: {
    leftImg() {
      return utils.webpUrl(this.params.leftImg, {
        isImageTag: true,
      })
    },
    rightImg() {
      return utils.webpUrl(this.params.rightImg, {
        isImageTag: true,
      })
    },
  },
  methods: {
    goToNy() {
      trackEvent('userteam_fx_home_oil_ck','进加油落地页按钮')
      const xspmInfo = {
        a: '',
        b: this.template,
        c: chapter[this.template].toNy,
        d: '',
      }
      sendXspmClick({}, xspmInfo)
      goTo({
        url: this.params.leftLink,
        extParams: {
          xspmInfo,
          // eslint-disable-next-line @didi/fin-check/usage-mpx-mode
          noCompileDchn: __mpx_mode__ === 'web' && !is('miniprogram'), // 小程序和端 需要解析dchn
        },
      })
    },
    goToDj() {
      trackEvent('userteam_fx_home_driver_ck','进代驾落地页按钮')
      const xspmInfo = {
        a: '',
        b: this.template,
        c: chapter[this.template].toDj,
        d: '',
      }
      sendXspmClick({}, xspmInfo)
      goTo({
        url: this.params.rightLink,
        extParams: {
          xspmInfo,
          // eslint-disable-next-line @didi/fin-check/usage-mpx-mode
          noCompileDchn: __mpx_mode__ === 'web' && !is('miniprogram'), // 小程序和端 需要解析dchn
        },
      })
    },
  },
})
</script>

<style lang="stylus" scoped>
.container
  display flex
  justify-content space-evenly
  margin 40rpx auto
  .resouce
    width 335rpx
    height 171rpx
</style>

<script type="application/json">
{
  "component": true
}
</script>
